import { Component } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import LockIcon from "images/partners/lock.svg?raw"
import parse from "html-react-parser"

import styles from "./permission_form.module.scss"

export default class PermissionForm extends Component {
  constructor(props) {
    super(props)
  }

  activeText(step_type, list_type) {
    switch (step_type) {
      case "trigger":
        return this.triggerActiveText(list_type)
      case "action":
        return this.actionActiveText(list_type)
    }
  }

  triggerActiveText(list_type) {
    switch (list_type) {
      case "denylist":
        return (
          <b>
            This trigger is allowed with all actions{" "}
            <span className={styles.active}>except</span> actions from the following
            services:
          </b>
        )
      case "allowlist":
        return (
          <b>
            This trigger is <span className={styles.active}>only allowed</span> with
            actions from the following services:
          </b>
        )
      default:
        return <b>This trigger is allowed with all services and actions</b>
    }
  }

  actionActiveText(list_type) {
    switch (list_type) {
      case "denylist":
        return (
          <b>
            This action is allowed with all triggers{" "}
            <span className={styles.active}>except</span> triggers from the following
            services:
          </b>
        )
      case "allowlist":
        return (
          <b>
            This action is <span className={styles.active}>only allowed</span> with
            triggers from the following services:
          </b>
        )
      default:
        return <b>This action is allowed with all services and triggers</b>
    }
  }

  render() {
    return (
      <section className={classnames("form-section", styles.permissions)}>
        <a id="permissions"></a>
        <h3>Permissions</h3>

        <p>
          Permissions are a great way for service owners to control and grant
          access to other service owners.
        </p>

        {this.activeText(this.props.step_type, this.props.list_type)}

        <ul className={styles["permission-list"]}>
          {this.props.channels.map(c => (
            <ListItem key={c.data.name} channel={c.data} />
          ))}
        </ul>

        <div className={styles.cta}>
          <span className="svg-icon">{parse(LockIcon)}</span>
          <p>
            <a
              className="pop-zendesk-widget"
              href="mailto:platform-support@ifttt.com?subject=Service Permissions"
            >
              Contact us
            </a>{" "}
            to change this {this.props.step_type}'s permissions
          </p>
        </div>
      </section>
    )
  }
}

function ListItem({ channel }) {
  return (
    <li>
      <img
        src={channel.image_url}
        title={channel.name}
        alt={channel.name}
        height="32"
        width="32"
      />
      {channel.name}
    </li>
  )
}

PermissionForm.propTypes = {
  list_type: PropTypes.string,
  channels: PropTypes.array,
  step_type: PropTypes.string,
}
